"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsResponseSchema = exports.eventItemSchema = exports.supportedChangeItemEventDataSchema = void 0;
const zod_1 = require("zod");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const contactDetails_schema_1 = require("../../../common/schemas/contactDetails.schema");
const eventData_schema_1 = require("./eventData.schema");
const eventData_schema_2 = require("../../../common/schemas/eventData.schema");
exports.supportedChangeItemEventDataSchema = zod_1.z.union([
    eventData_schema_1.changeItemCreatedEventDataSchema,
    eventData_schema_1.changeItemReceivedEventDataSchema,
    eventData_schema_1.changeItemReviewResponseEventDataSchema,
    eventData_schema_1.changeItemClosedEventDataSchema,
    eventData_schema_1.changeItemForwardedEventDataSchema,
    eventData_schema_1.changeItemModifiedEventDataSchema,
    eventData_schema_1.changeItemSentEventDataSchema,
    eventData_schema_2.projectItemDeletedEventDataSchema,
    eventData_schema_2.workflowActionFileTransferFailedEventDataSchema,
    eventData_schema_2.workflowActionFailedEventDataSchema,
    eventData_schema_2.workflowActionCancelledEventDataSchema,
    eventData_schema_1.changeItemWorkflowActionFileDownloadedEventDataSchema,
    eventData_schema_1.changeItemReopenedEventDataSchema,
    eventData_schema_1.changeItemProposalRequestedEventDataSchema,
    eventData_schema_1.changeItemProposalUpdateRequestedEventDataSchema,
    eventData_schema_1.changeItemWorkflowActionExternalFileDownloadedEventDataSchema,
    eventData_schema_1.changeItemProposalSubmittedEventDataSchema,
    eventData_schema_1.changeItemSignatureRequestedEventDataSchema,
    eventData_schema_1.changeItemSignatureSubmittedEventDataSchema,
    eventData_schema_1.changeItemSignedProposalSentEventDataSchema,
    eventData_schema_1.changeItemReceivedPendingEventDataSchema,
]);
exports.eventItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    performedOn: datetime_schema_1.datetimeSchema,
    performedBy: contactDetails_schema_1.contactDetailsSchema,
    type: zod_1.z.string().refine((value) => /^((CHANGE_ITEM_[A-Z_]+)|(RELATED_ITEM_[A-Z_]+))$/.test(value), {
        message: "Invalid change item event type",
    }),
    data: exports.supportedChangeItemEventDataSchema,
    dataVersion: zod_1.z.string(),
})
    .strict();
exports.eventsResponseSchema = zod_1.z
    .object({
    items: exports.eventItemSchema.array(),
})
    .strict();
//# sourceMappingURL=eventResponse.schema.js.map